import * as React from 'react'
import { INestedProduct } from '@getgreenline/homi-shared'
import { PrintProductLink } from './PrintProductLink'
import { Menu } from 'antd'

interface Props {
  product: INestedProduct
}

export const PrintProductCheck = (props: Props) => {
  const { product } = props
  const childProductsWithBarcode = product.childProducts.filter(
    (childProduct) => childProduct.barcode,
  )

  return (
    <>
      {
        // Only provide the option to print the barcode of a parent product if bulk
        product.barcode ? (
          <Menu.Item {...props}>
            <PrintProductLink productItem={product} />
          </Menu.Item>
        ) : (
          <Menu.Item disabled {...props}>
            <PrintProductLink productItem={product} />
          </Menu.Item>
        )
      }

      {childProductsWithBarcode.map((childProduct) => (
        <Menu.Item key={childProduct.id} {...props}>
          <PrintProductLink productItem={childProduct} />
        </Menu.Item>
      ))}
    </>
  )
}
